import { WeaTools } from 'ecCom'

export const getSearchCondition = (params) => {
    return WeaTools.callApi('/api/hrm/schedulediffreport/getSearchCondition', 'POST', params);
}

export const getReportData = (params) => {
    return WeaTools.callApi('/api/hrm/schedulediffreport/getReportData', 'POST', params);
}

export const getTableData = params => {
    return WeaTools.callApi('/api/hrm/kq/report/getHrmKQReportDetialInfo', 'POST', params);
}

export const getHrmKQReportDetialTabInfo = (params) => WeaTools.callApi('/api/hrm/kq/report/getHrmKQReportDetialTabInfo', 'POST', params)
export const getTabTableData = (params = {}) => Promise.all([getHrmKQReportDetialTabInfo(), getTableData()])


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/apis/schedulediffreport.js